import React from 'react'
import "./OnBoarding.css";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { PROJECT_DISPLAY_NAME } from '../../../config/apiConfig';

export default function AccountPreferences() {
  return (
    <div className='domainpref_wrapper pt-4'>
    <div className='container'>
      <div className='row'>
      <div className='col-md-6 form_center text-center'>
          <div className='domainpref_form_block'>
          <h5 className='fill_info_head'>What do you need {PROJECT_DISPLAY_NAME} to help with?</h5>
            <p className='fill_info_para'>Select a few companies your business may need helps us provide more personalised product recommendations</p>
            <Form name="information" className="domainpref_form_info mt-4">
            <div className="search_box_block mb-4">
              <div className="search-box">
                <input type="search" placeholder="Search companies" className="search_input"/>
                  <i className="fa fa-search fa-lg"></i>
              </div>
            </div>
              <div className='row'>
                <div className='col-md-6'>
                  <div className='domain_checkbox_block'>
                      <div className='icons_name_domain'>
                        <p className='domain_text'>Baker Hughes</p>
                      </div>
                      <div className='checkbox_pref'>
                      <input type="checkbox" className='checkbox_co'/>
                      </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='domain_checkbox_block'>
                      <div className='icons_name_domain'>
                        <p className='domain_text'>General Electric</p>
                      </div>
                      <div className='checkbox_pref'>
                      <input type="checkbox" className='checkbox_co'/>
                      </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='domain_checkbox_block'>
                      <div className='icons_name_domain'>
                        <p className='domain_text'>Exxonmobil</p>
                      </div>
                      <div className='checkbox_pref'>
                      <input type="checkbox" className='checkbox_co'/>
                      </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='domain_checkbox_block'>
                      <div className='icons_name_domain'>
                        <p className='domain_text'>Honeywell International, Inc.</p>
                      </div>
                      <div className='checkbox_pref'>
                      <input type="checkbox" className='checkbox_co'/>
                      </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='domain_checkbox_block'>
                      <div className='icons_name_domain'>
                        <p className='domain_text'>Chevron Corp.</p>
                      </div>
                      <div className='checkbox_pref'>
                      <input type="checkbox" className='checkbox_co'/>
                      </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='domain_checkbox_block'>
                      <div className='icons_name_domain'>
                        <p className='domain_text'>Shell plc</p>
                      </div>
                      <div className='checkbox_pref'>
                      <input type="checkbox" className='checkbox_co'/>
                      </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='domain_checkbox_block'>
                      <div className='icons_name_domain'>
                        <p className='domain_text'>Marathon Petroleum Crop</p>
                      </div>
                      <div className='checkbox_pref'>
                      <input type="checkbox" className='checkbox_co'/>
                      </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='domain_checkbox_block'>
                      <div className='icons_name_domain'>
                        <p className='domain_text'>Totalenergies</p>
                      </div>
                      <div className='checkbox_pref'>
                      <input type="checkbox" className='checkbox_co'/>
                      </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='domain_checkbox_block'>
                      <div className='icons_name_domain'>
                        <p className='domain_text'>Cadillac Fairview</p>
                      </div>
                      <div className='checkbox_pref'>
                      <input type="checkbox" className='checkbox_co'/>
                      </div>
                  </div>
                </div>
                <div className='clearfix'></div>
                <div className='col-md-6'>
                  <div className='see_all_ind'>
                    <p className='see_all_para'>Select all Companies </p>
                    <input type="checkbox" className='checkbox_co'/>
                  </div>
                </div>
                <div className='col-md-12 mt-4'>
                  <div className='prev_next_block'>
                    <Button className="previous_btn">
                      Previous
                    </Button>
                    <Button className="next_btn_blue">
                      Next <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </Button>
                  </div>
                </div>
              </div>
            </Form>
          </div>
      </div>
      </div>
    </div>
  </div>
  )
}
